import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";
import routesName from "@/utils/constants/routesName";
import { useUserStore } from "@/stores/user";
import { useRoute } from "vue-router";
import { UserRoleEnum } from "@/utils/enum/UserRoleEnum";


export default /*#__PURE__*/_defineComponent({
  __name: 'MainLayout',
  setup(__props, { expose: __expose }) {
  __expose();

const userStore = useUserStore();
const route = useRoute();

const drawer = ref(false);
const menuItemsAll = ref([
  {
    title: "Courses",
    routerName: routesName.courses,
    icon: "mdi-school",
  },
  {
    title: "Learning centers",
    routerName: routesName.learningCenters,
    icon: "mdi-book-open",
  },
  {
    title: "Users",
    routerName: routesName.users,
    icon: "mdi-account-group",
    roles: [UserRoleEnum.admin],
  },
  {
    title: "User management",
    routerName: routesName.managers,
    icon: "mdi-account-tie",
    roles: [UserRoleEnum.admin],
  },
  {
    title: "Trending specialties",
    routerName: routesName.trendingSpecialties,
    icon: "mdi-trending-up",
    roles: [UserRoleEnum.admin],
  },
  {
    title: "Settings",
    routerName: routesName.settings,
    icon: "mdi-cog",
    roles: [UserRoleEnum.admin],
  },
]);

const menuItems = computed(() =>
  menuItemsAll.value.filter((i) => {
    return i.roles?.length && userStore.userData?.role
      ? i.roles.includes(userStore.userData.role)
      : i;
  })
);

const __returned__ = { userStore, route, drawer, menuItemsAll, menuItems, computed, ref, get routesName() { return routesName }, get useUserStore() { return useUserStore }, get useRoute() { return useRoute }, get UserRoleEnum() { return UserRoleEnum } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})